import { useEffect, useState } from "react";
import type { Session, User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const enforcePersistence = async (s: Session | null) => {
      if (!s) return s;
      try {
        const sessionOnly = sessionStorage.getItem("otv_session_only") === "1";
        const untilRaw = localStorage.getItem("otv_remember_until");
        const until = untilRaw ? Number(untilRaw) : 0;
        const remembered = until > Date.now();
        // If neither flag is present, treat as legacy login — keep as remembered.
        const hasFlag = sessionOnly || untilRaw;
        if (hasFlag && !sessionOnly && !remembered) {
          await supabase.auth.signOut();
          localStorage.removeItem("otv_remember_until");
          return null;
        }
      } catch {}
      return s;
    };

    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (_event, s) => {
      const next = await enforcePersistence(s);
      setSession(next);
      setUser(next?.user ?? null);
      setLoading(false);
    });
    supabase.auth.getSession().then(async ({ data }) => {
      const next = await enforcePersistence(data.session);
      setSession(next);
      setUser(next?.user ?? null);
      setLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return { session, user, loading };
}
